<template>
  <div>
    <perfect-scrollbar
      ref="scrollbar"
      :options="{suppressScrollX: true}"
      :style="`height: ${height};max-height: ${maxHeight};`"
      @ps-scroll-y="onScrollY"
      @ps-scroll-x="$emit('onScrollX')"
    >
      <slot />
    </perfect-scrollbar>
  </div>
</template>
<script>
export default {
  name: 'ScrollBar',
  props: {
    height: {
      type: String,
      default: '100%',
    },
    maxHeight: {
      type: String,
      default: '100%',
    },
    zIndex: {
      type: Number,
      default: undefined,
    },
    breakpoint: {
      type: Number,
      default: 200,
    },
  },
  methods: {
    onScrollY() {
      const { scrollbar } = this.$refs;
      const remainingScrollHeight = scrollbar.ps.contentHeight - scrollbar.ps.lastScrollTop - scrollbar.ps.containerHeight;
      if (remainingScrollHeight < this.breakpoint) {
        this.$emit('reachedYBreakpoint');
      }
      this.$emit('onScrollY');
    },
  },
  mounted() {
    if (this.zIndex) {
      const { scrollbar } = this.$refs;
      const rail = scrollbar.$el.querySelector('.ps__rail-y');
      rail.style.zIndex = this.zIndex;
    }
  },
};
</script>
